import * as React from "react";
import { Facet, useSearch } from "@elastic/react-search-ui";

/**
 * Temporary workaround. Move the custom sorting order to the widget configuration.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function OpenSearchFacetWithCustomItemsOrder(props) {
  const {field, label, show, customOrder} = props;
  return (
    <div className='facet'>
      <details open={true}>
        <summary>
          <span>{label}</span>
          <div className="facet__arrow"></div>
        </summary>
        <Facet field={field} show={show} label={label} filterType='any' view={({options, onSelect, onRemove}) => {

          const sortedOptions = [...options].sort(
            (a, b) =>
              customOrder.indexOf(a.value) - customOrder.indexOf(b.value)
          );

          return (
            <fieldset className='sui-facet'>
              <legend className="sui-facet__title">{label}</legend>
              <div className="sui-multi-checkbox-facet">
                {sortedOptions.map(option => {
                  return (
                    <label className='sui-multi-checkbox-facet__option-label' key={option?.value}>
                      <span className="sui-multi-checkbox-facet__option-input-wrapper">
                        <input type="checkbox" className="sui-multi-checkbox-facet__checkbox" checked={option.selected}
                               onChange={() => {
                                 if (option.selected) {
                                   onRemove(option.value);
                                 } else {
                                   onSelect(option.value);
                                 }
                               }}/>
                        <span className='sui-multi-checkbox-facet__input-text'>{option.value}</span>
                      </span>
                      <span className="sui-multi-checkbox-facet__option-count">
                        {option.count}
                      </span>
                    </label>
                  );
                })}
              </div>
            </fieldset>
          );
        }}/>
      </details>
    </div>
  );
}

export default function OpenSearchFacet(props) {
  const {field, label, show} = props;

  if (field === 'learning_level') {
    const customOrder = ["General Interest", "Technical - Beginner", "Technical - Intermediate", "Technical - Advanced"];

    return (
      <OpenSearchFacetWithCustomItemsOrder
        field={field}
        label={label}
        show={show}
        customOrder={customOrder}/>
    );
  }

  return (
    <div className='facet'>
      <details open={true}>
        <summary>
          <span>{label}</span>
          <div className="facet__arrow"></div>
        </summary>
        <Facet field={field} show={show} label={label} filterType='any'/>
      </details>
    </div>
  );
}
